import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpModule, JsonpModule } from '@angular/http';
import { RouterModule, Routes } from '@angular/router';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AppComponent } from './app.component';
import { SideMenuComponent } from './side-menu/side-menu.component';
import { ApplicationManagementComponent } from './members/application-management/application-management.component';
import { InviteManagementComponent } from './members/invite-management/invite-management.component';
import { MemberManagementComponent } from './members/member-management/member-management.component';
import { HomeComponent } from './home/home.component';
import { UserComponent } from './members/application-management/user.component';
import { LoginComponent } from './authorization/login.component';
import { ResetPasswordComponent } from './authorization/reset-password.component';
import { ConfirmPasswordComponent } from './authorization/confirm-password.component';
import { MemberDatabaseComponent } from './members/member-management/member-database.component';
import { GroupDatabaseComponent } from './venues/group-database/group-database.component';
import { CreateGroupComponent } from './venues/create-group/create-group.component';

import { DropdownComponent } from './shared/dropdown/dropdown.component';
import { SliderComponent } from './shared/slider/slider.component';
import { SpinnerComponent } from './shared/spinner/spinner.component';

import { TokenManagerService } from './shared/services/token-login.service';
import { AuthGuard } from './shared/services/auth-guard.service';
import { HttpRequestService } from './shared/services/http-request.service';

import { ApplicationManagementTableComponent } from './members/application-management/application-management-table.component';
import { VenueBillingComponent } from './venues/venue-billing/venue-billing.component';
import { VenueDatabaseComponent } from './venues/venue-database/venue-database.component';
import { UserManagementComponent } from './user-management/user-management.component';
import { UserDetailsComponent } from './user-management/user-details/user-details.component';
import { EqualValidatorDirective } from './authorization/equal-validator.directive';
import { DeleteUserComponent } from './user-management/user-details/delete-user.component';
import { AddUserComponent } from './user-management/user-details/add-user.component';
import { PaginationControlsComponent } from './shared/pagination/pagination.component';
import { GridComponent } from './shared/grid/grid.component';

import { VenueDetailsComponent } from './venues/venue-details/venue-details.component';
import { AppInvitesComponent } from './members/member-management/member-actions/app-invites.component';
import { ExpiryDatesComponent } from './members/member-management/member-actions/expiry-dates.component';
import { EmailValidatorDirective } from './email-validator.directive';
import { MapsComponent } from './shared/g-maps/gmaps.component';
import {
  DxButtonModule,
  DxDataGridModule, DxDateBoxModule, DxNumberBoxModule, DxSelectBoxModule,
  DxTextBoxModule, DxValidatorModule
} from 'devextreme-angular';
import { SearchPipe } from './user-management/search-users.pipe';
import { FilterVenuesPipe } from './filter-venues.pipe';
import { ToasterService, ToasterModule } from 'angular2-toaster';
import { PopUpDialogComponent } from './shared/pop-up-dialog/pop-up-dialog.component';
import { DebounceComponent } from './shared/debounce/debounce.component';
import { DndModule } from 'ng2-dnd';
// import { AgmCoreModule } from 'angular2-google-maps/core';
import { AddNewCoverComponent } from './venues/venue-details/add-new-cover/add-new-cover.component';
import { AddNewCoverMemberSearchPipe } from './venues/venue-details/add-new-cover/add-new-cover-member-search.pipe';
import { PushMessageVenueSearchPipe } from './push-messages/push-message-details/push-message-details-venue-search.pipe';
import { PushMessageEventSearchPipe } from './push-messages/push-message-details/push-message-details-event-search.pipe';
import { PushMessageBarSearchPipe } from './push-messages/push-message-details/push-message-details-bar-search.pipe';
import { EventDatabaseComponent } from './events/event-database/event-database.component';
import { EventDetailsComponent } from './events/event-details/event-details.component';
import { EditGuestsComponent } from './events/event-database/edit-guests/edit-guests.component';
import { EditQuestsSearchPipe } from './events/event-database/edit-guests/edit-quests-search.pipe';
import { AddEditGuestComponent } from './events/event-database/edit-guests/add-edit-guest/add-edit-guest.component';
import { ImagePreviewComponent } from './shared/image-preview/image-preview.component';
import { TinyEditorComponent } from './shared/tinyeditor/tinyeditor';
import { BugsnagErrorHandler } from './shared/bugsnag/error-handler';
import { ContactNightKeyComponent } from './contact-nightkey/contact-nightkey.component';
import { PushMessageDatabaseComponent } from './push-messages/push-messages-database/push-message-database.component';
import { PushMessageDetailsComponent } from './push-messages/push-message-details/push-message-details.component';
import { AnalyticsTableComponent } from './members/application-management/analitycs/analytics-table/analytics-table.component';








const appRoutes: Routes = [
  { path: 'Home', canActivate: [AuthGuard], component: HomeComponent },
  { path: 'Login', component: LoginComponent },
  { path: 'ResetPassword', component: ResetPasswordComponent },
  { path: 'ConfirmPassword/:hash', component: ConfirmPasswordComponent },
  { path: 'ApplicationManagement', canActivate: [AuthGuard], component: ApplicationManagementComponent },
  { path: 'InviteManagement', canActivate: [AuthGuard], component: InviteManagementComponent },
  { path: 'MemberManagement', canActivate: [AuthGuard], component: MemberManagementComponent },
  { path: 'GroupDatabase', canActivate: [AuthGuard], component: GroupDatabaseComponent },
  { path: 'VenueBilling', canActivate: [AuthGuard], component: VenueBillingComponent },
  { path: 'VenueDatabase', canActivate: [AuthGuard], component: VenueDatabaseComponent },
  { path: 'EventDatabase', canActivate: [AuthGuard], component: EventDatabaseComponent },
  { path: 'PushMessageDatabase', canActivate: [AuthGuard], component: PushMessageDatabaseComponent },
  { path: 'UserManagement', canActivate: [AuthGuard], component: UserManagementComponent },
  { path: 'ContactNightKey', canActivate: [AuthGuard], component: ContactNightKeyComponent },
  { path: '', redirectTo: 'Home', pathMatch: 'full' },
  { path: '**', redirectTo: 'Home', pathMatch: 'full' },

];

@NgModule({
  declarations: [
    AppComponent,
    SideMenuComponent,
    ApplicationManagementComponent,
    InviteManagementComponent,
    MemberManagementComponent,
    HomeComponent,
    LoginComponent,
    ResetPasswordComponent,
    ConfirmPasswordComponent,
    UserComponent,
    ContactNightKeyComponent,
    LoginComponent,
    MemberDatabaseComponent,
    GroupDatabaseComponent,
    CreateGroupComponent,
    DropdownComponent,
    SliderComponent,
    SpinnerComponent,
    ApplicationManagementTableComponent,
    AnalyticsTableComponent,
    VenueBillingComponent,
    VenueDatabaseComponent,
    UserManagementComponent,
    UserDetailsComponent,
    EqualValidatorDirective,
    DeleteUserComponent,
    AddUserComponent,
    GridComponent,
    PaginationControlsComponent,
    VenueDetailsComponent,
    AppInvitesComponent,
    ExpiryDatesComponent,
    EmailValidatorDirective,
    MapsComponent,
    SearchPipe,
    FilterVenuesPipe,
    PopUpDialogComponent,
    DebounceComponent,
    AddNewCoverComponent,
    AddNewCoverMemberSearchPipe,
    PushMessageEventSearchPipe,
    PushMessageBarSearchPipe,
    PushMessageVenueSearchPipe,
    EventDatabaseComponent,
    EventDetailsComponent,
    EditGuestsComponent,
    EditQuestsSearchPipe,
    AddEditGuestComponent,
    ImagePreviewComponent,
    TinyEditorComponent,
    PushMessageDetailsComponent,
    PushMessageDatabaseComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    HttpModule,
    JsonpModule,
    BrowserAnimationsModule,
    RouterModule.forRoot(appRoutes),
    DxDataGridModule,
    ToasterModule,
    DndModule.forRoot(),
    DxDateBoxModule,
    DxNumberBoxModule,
    DxSelectBoxModule,
    DxTextBoxModule,
    ToasterModule,
    DxButtonModule,
    DxValidatorModule
    // AgmCoreModule.forRoot({
    //   apiKey: 'AIzaSyDhzE8BeEttdsoHttOfwRBrdtwKRKKU3pI'
    // })
  ],
  providers: [TokenManagerService, AuthGuard, HttpRequestService, ToasterService, { provide: ErrorHandler, useClass: BugsnagErrorHandler }],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// C:/NightKey/CMS/nightkey-cms/src/app/app.module.ts